import React, { useState, useEffect } from "react";
import { OpusAiIcon } from "./OpusAiIcon";
import Text from "@src/lib/ui/Text";

export type AiChatAvatarStatus =
  | "submitted"
  | "streaming"
  | "ready"
  | "searching"
  | "checking_data";

interface AiChatAvatarProps {
  status?: AiChatAvatarStatus;
  name?: string;
}

export const AiChatAvatar: React.FC<AiChatAvatarProps> = ({
  status = "ready",
  name,
}) => {
  const [dotIndex, setDotIndex] = useState(0);
  const dots = [".", "..", "..."];

  useEffect(() => {
    if (status === "ready") return;

    const interval = setInterval(() => {
      setDotIndex((prev) => (prev + 1) % dots.length);
    }, 500);

    return () => clearInterval(interval);
  }, [status, dots.length]);

  const getDisplayText = () => {
    switch (status) {
      case "streaming":
      case "submitted":
        return "Thinking";
      case "searching":
        return "Searching files";
      case "checking_data":
        return "Checking your team's data";
      case "ready":
      default:
        return name || "Ask Opus";
    }
  };

  const displayText =
    getDisplayText() + (status !== "ready" ? dots[dotIndex] : "");

  return (
    <div className="flex items-center gap-[6px]">
      <OpusAiIcon size={20} />
      <div className="flex items-center gap-2">
        <Text variant="fine-print-title">{displayText}</Text>
      </div>
    </div>
  );
};
